import script from "./TriverconservContactForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TriverconservContactForm.vue?vue&type=script&lang=ts&setup=true"

import "./TriverconservContactForm.vue?vue&type=style&index=0&id=9fb39ef4&lang=scss"

const __exports__ = script;

export default __exports__